module.exports = __webpack_public_path__ + "ae90c5f0c8a7e7d0dca86821959b50c4.png";